import { inboundShipmentProductIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

const SupplierContactSchema_ = z.object({
  name: z.string(),
  email: z.string(),
});

export const SupplierContactSchema: z.ZodType<SupplierContactSchema> =
  SupplierContactSchema_;
export interface SupplierContactSchema extends z.infer<
  typeof SupplierContactSchema_
> {}

const ProductInfoSchema_ = z.object({
  sku: z.string().nullable(),
  title: z.string(),
  damagedQuantity: z.number(),
  missingQuantity: z.number(),
  unitCost: z.number(),
  costCurrency: z.string(),
  totalLoss: z.number(),
});

export const ProductInfoSchema: z.ZodType<ProductInfoSchema> =
  ProductInfoSchema_;
export interface ProductInfoSchema extends z.infer<typeof ProductInfoSchema_> {}

const GenerateDisputeEmailOutputSchema_ = z.object({
  subject: z.string(),
  body: z.string(),
  supplierName: z.string().nullable(),
  supplierContacts: z.array(SupplierContactSchema),
  productInfo: ProductInfoSchema,
  poNumber: z.string().nullable(),
});

export const GenerateDisputeEmailOutputSchema: z.ZodType<GenerateDisputeEmailOutput> =
  GenerateDisputeEmailOutputSchema_;
export interface GenerateDisputeEmailOutput extends z.infer<
  typeof GenerateDisputeEmailOutputSchema_
> {}

export const generateDisputeEmail = {
  name: "generateDisputeEmail" as const,
  input: z.object({
    inboundShipmentProductId: inboundShipmentProductIdFormat.schema,
    damageDescription: z.string().optional(),
  }),
  output: GenerateDisputeEmailOutputSchema,
  files: true as const,
};
